import React, { useRef, useState } from "react";
import { Button, InputGroup } from "reactstrap";
import { BlkField } from "../../../coms/BlkField";
import { useFormikContext } from "formik";
import { PolicyExcelUploadProps } from "../schemas/policy.types";
import { ALLOWED_EXCEL_EXTENSIONS } from "../schemas/policy-excel.constants";

export const UploadPolicyFile: React.FC<Omit<PolicyExcelUploadProps, "setFieldValue">> = ({ name, maxSizeMB = 5 }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const { setFieldValue } = useFormikContext();

    const [fileName, setFileName] = useState<string>("");

    const openSelector = () => {
        fileInputRef.current?.click();
    };

    const validateFile = (file: File): string | null => {
        const isValidExtension = ALLOWED_EXCEL_EXTENSIONS.some(ext => file.name.toLowerCase().endsWith(ext));

        if (!isValidExtension) return "Solo se permiten archivos Excel " + ALLOWED_EXCEL_EXTENSIONS;

        const maxBytes = maxSizeMB * 1024 * 1024;

        if (file.size > maxBytes) return `El archivo supera ${maxSizeMB}MB`;

        return null;
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (!file) return;

        const isInvalidFile = validateFile(file);

        if (isInvalidFile) {
            setFileName("");
            void setFieldValue(name, null);
            return;
        }

        setFileName(file.name);
        void setFieldValue(name, file);
    };

    const removeFile = () => {
        setFileName("");

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }

        void setFieldValue(name, null);
    };

    return (
        <>
            <InputGroup className="mt-4">
                <BlkField
                    name={`${name}Name`}
                    value={fileName}
                    type="text"
                    className="form-control mx-3"
                    readOnly
                    placeholder="Seleccione un archivo Excel"
                />

                <Button type="button" color="primary" onClick={openSelector}>
                    Cargar
                </Button>

                {fileName && (
                    <Button type="button" className="btn btn-outline-primary" onClick={removeFile}>
                        Quitar
                    </Button>
                )}
            </InputGroup>

            <input
                type="file"
                ref={fileInputRef}
                accept={ALLOWED_EXCEL_EXTENSIONS.join(",")}
                hidden
                onChange={handleFileChange}
            />
        </>
    );
};
